import React, { FunctionComponent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IDeviceModel } from 'interfaces';

interface IModelsListItemProps {
    manufacturer: string;
    model: IDeviceModel;
}

export const ModelsListItem: FunctionComponent<IModelsListItemProps> = ({ model, manufacturer }) => {
    const { t, i18n } = useTranslation();

    const editModelURL = `/models/${model.id}`;

    // Each string goes in a div as well as a title, so precompute translations to avoid doing them twice.
    const t_is_deleted = t('modelsList.item.isDeleted');
    const t_isDeletedTitle = t_is_deleted + ' ' + model.is_deleted;

    return (
        <li className="modelsItem" data-cy="deviceItem_device">
            
            <div className="modelsItem_iconCol modelsItem_col">
                <div className="modelsItem_iconCircle">
                    <FontAwesomeIcon icon="hdd" className="modelsItem_icon" />
                </div>
            </div>
            <div className="modelsItem_detailsCol modelsItem_col">
                <div className="modelsItem_name ellipsis" title={model.manufacturer_id + ''}>
                    {manufacturer}
                </div>
            </div>
            <div className="modelsItem_detailsCol modelsItem_col">
                <div className="modelsItem_name ellipsis" title={model.name}>
                    {model.name}
                </div>
            </div>
            {model.is_deleted ? (
                <div className="modelsItem_detailsCol modelsItem_col">
                    <div className="modelsItem_detailsLeft modelsItem_col">
                        <div className="ellipsis" title={t_isDeletedTitle}>
                            {t_is_deleted}
                        </div>
                    </div>
                    <div className="modelsItem_detailsRight modelsItem_col">
                        <div className="ellipsis" title={t_isDeletedTitle}>
                            True
                        </div>
                    </div>
                </div>
            ) : (<>
                <div className="modelsItem_detailsCol modelsItem_col">
                    <div className="modelsItem_detailsLeft">
                    </div>
                </div></>)}
            <Link
                to={editModelURL}
                className="modelsItem_editCol"
                title={t('modelsList.item.editTooltip')}
                data-cy="deviceItem_editLink"
            >
                <FontAwesomeIcon icon={['far', 'edit']} className="modelsItem_editIcon" />
            </Link>
        </li>
    );
}